import { render, staticRenderFns } from "./CardStandard.vue?vue&type=template&id=bd197dbc&scoped=true&"
import script from "./CardStandard.vue?vue&type=script&lang=js&"
export * from "./CardStandard.vue?vue&type=script&lang=js&"
import style0 from "./CardStandard.vue?vue&type=style&index=0&id=bd197dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd197dbc",
  null
  
)

/* custom blocks */
import block0 from "./CardStandard.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports